export function newIdempotencyKey(prefix?: string) {
  // Backend requires idempotency_key for gift endpoints; keep it short and unique.
  const base =
    (globalThis.crypto && typeof globalThis.crypto.randomUUID === 'function')
      ? globalThis.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`
  return prefix ? `${prefix}-${base}` : base
}

